import { render, staticRenderFns } from "./MotorBikeRightDamage.vue?vue&type=template&id=5dfb4a10"
import script from "./MotorBikeRightDamage.vue?vue&type=script&lang=js"
export * from "./MotorBikeRightDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports